import React from 'react';
import { History, Clock, Send, Trash2, RefreshCw, Lightbulb, FileText, Paperclip, RotateCcw } from 'lucide-react';
import Card from '../../../components/Card/Card';
import SectionHeader from '../../../components/SectionHeader/SectionHeader';

function HistoriqueTab() {
  return (
    <>
      {/* Section: Qu'est-ce que l'historique */}
      <Card className="card-large">
        <SectionHeader icon={History} title="L'historique des dictées" variant="default" />
        <div className="guide-section-content">
          <div className="guide-info">
            <History className="guide-info-icon" size={20} />
            <p>
              L'historique contient toutes vos <strong>dictées transcrites</strong>, accessibles
              depuis le dictaphone. Chaque dictée a un statut : brouillon, envoyé ou supprimé.
            </p>
          </div>
        </div>
      </Card>

      {/* Section: Statuts */}
      <Card className="card-large">
        <SectionHeader icon={Clock} title="Statuts des dictées" variant="info" />
        <div className="guide-section-content">
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon orange">
                <Clock size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Brouillon</h4>
                <p>Dictée transcrite mais pas encore envoyée pour générer un rapport</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon green">
                <Send size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Envoyé</h4>
                <p>Dictée transformée en rapport, visible dans l'onglet Rapports</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon primary">
                <Trash2 size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Corbeille</h4>
                <p>Dictées supprimées depuis le dictaphone</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Durée de conservation */}
      <Card className="card-large">
        <SectionHeader icon={Clock} title="Durée de conservation" variant="warning" />
        <div className="guide-section-content">
          <div className="guide-info">
            <Clock className="guide-info-icon" size={20} />
            <p>
              <strong>7 jours d'historique</strong> pour les abonnements Silver et supérieurs.
              Les dictées plus anciennes sont supprimées automatiquement.
            </p>
          </div>
          <div className="guide-tip">
            <Lightbulb className="guide-tip-icon" size={20} />
            <p>
              Pensez à envoyer vos brouillons avant qu'ils n'expirent.
              Les rapports générés, eux, sont conservés indéfiniment.
            </p>
          </div>
        </div>
      </Card>

      {/* Section: Reprendre une dictée */}
      <Card className="card-large">
        <SectionHeader icon={RefreshCw} title="Reprendre une dictée" variant="success" />
        <div className="guide-section-content">
          <div className="guide-info">
            <RefreshCw className="guide-info-icon" size={20} />
            <p>
              <strong>Touchez une dictée</strong> dans l'historique pour la reprendre,
              la modifier ou continuer à dicter.
            </p>
          </div>
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon blue">
                <FileText size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Reprendre le texte seul</h4>
                <p>Récupérer uniquement la transcription, sans l'annexe</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon purple">
                <Paperclip size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Reprendre l'annexe seule</h4>
                <p>Récupérer uniquement les documents annexes</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Modifier le modèle */}
      <Card className="card-large">
        <SectionHeader icon={RotateCcw} title="Changer le modèle d'une dictée" variant="default" />
        <div className="guide-section-content">
          <div className="guide-info">
            <RotateCcw className="guide-info-icon" size={20} />
            <p>
              Vous pouvez <strong>modifier le modèle de rapport</strong> d'une dictée déjà envoyée.
              La même transcription sera utilisée pour générer un nouveau rapport avec un format différent.
            </p>
          </div>
          <div className="guide-tip">
            <Lightbulb className="guide-tip-icon" size={20} />
            <p>
              Exemple : vous avez envoyé une dictée en "Consultation" mais vous vouliez
              une "Lettre au confrère" ? Reprenez la dictée et changez le modèle.
            </p>
          </div>
        </div>
      </Card>
    </>
  );
}

export default HistoriqueTab;
